<div>
  <div *ngIf="authService.user; else visitor">
    <!-- User -->
    <div class="p-4 pt-8 md:pt-4">
      <div class="mb-8">
        <p>You are logged in as {{ authService.user.email }}</p>
        <p>UserId: {{ authService.user.uid }}</p>
        <p class="text-yellow-700" *ngIf="!authService.user.emailVerified">
          Your email address is not verified. Please check your inbox, or
          <span
            class="underline cursor-pointer"
            (click)="resendEmailVerification()"
            >resend verification email</span
          >.
        </p>
      </div>
      <h2 class="text-lg mb-2">Manage</h2>
      <ul>
        <li
          (click)="changeEmail()"
          *ngIf="authService.isEmailSignup()"
          class="cursor-pointer mb-2 hover:underline text-blue-500"
        >
          Change email
        </li>
        <li
          (click)="resetPassword()"
          *ngIf="authService.isEmailSignup()"
          class="cursor-pointer mb-2 hover:underline text-blue-500"
        >
          Password reset
        </li>
        <li
          (click)="logout()"
          class="cursor-pointer mb-8 hover:underline text-blue-500"
        >
          Log out
        </li>
      </ul>
      <h2 class="text-lg mb-2">More</h2>
      <ul>
        <li
          (click)="deleteAccount()"
          class="cursor-pointer mb-2 hover:underline text-red-500"
        >
          Delete account
        </li>
      </ul>
    </div>

    <!-- <div class="block !sm:hidden">
      <mat-action-list>
        <mat-list-item
          (click)="changeEmail()"
          *ngIf="authService.isEmailSignup()"
        >
          <mat-icon matListItemIcon>mail</mat-icon>
          <span matListItemTitle>Change email</span>
        </mat-list-item>
        <mat-list-item
          (click)="resetPassword()"
          *ngIf="authService.isEmailSignup()"
        >
          <mat-icon matListItemIcon>password</mat-icon>
          <span matListItemTitle>Password reset</span>
        </mat-list-item>
        <mat-list-item (click)="logout()">
          <mat-icon matListItemIcon>logout</mat-icon>
          <span matListItemTitle>Log out</span>
        </mat-list-item>
        <mat-list-item (click)="deleteAccount()">
          <mat-icon matListItemIcon>delete</mat-icon>
          <span matListItemTitle>Delete account</span>
        </mat-list-item>
      </mat-action-list>
    </div> -->
  </div>

  <!-- Visitor -->
  <ng-template #visitor>
    <div class="p-4">
      <p>You are not logged in.</p>
      <span (click)="login()" class="text-blue-500 cursor-pointer mb-4 block"
        >Log in</span
      >
    </div>
  </ng-template>
</div>
